import { Check, Lock, Clock, XCircle } from "lucide-react";

const ICON = { done: Check, locked: Lock, waiting: Clock, failed: XCircle };
const LABEL = { done: "Completed", current: "In progress", locked: "Locked", waiting: "Awaiting admin setup", failed: "Not cleared" };

export default function Stepper({ steps, active, onSelect }) {
  return (
    <div className="stepper" data-testid="creator-stepper">
      {steps.map(s => {
        const Icon = ICON[s.status];
        return (
          <button key={s.n} type="button" className={`step-card ${s.status} ${active === s.n ? "active" : ""}`} disabled={s.status === "locked"} onClick={() => onSelect(s.n)} data-testid={`step-${s.key}`}>
            <span className="step-num">{Icon ? <Icon size={14} /> : s.n}</span>
            <span className="step-copy">
              <small>Step {s.n}</small>
              <strong>{s.title}</strong>
              <em data-testid={`step-${s.key}-status`}>{LABEL[s.status]}</em>
            </span>
          </button>
        );
      })}
    </div>
  );
}
